import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import "./FaqStyle.css";
import { deviceCheck } from "../../Values/utils";

type props = {};

const Faq: FunctionComponent<props> = ({ }) => {

    useEffect(() => {
        const allQuestions = document.querySelectorAll(".faq__ques");
        allQuestions.forEach((ques) => {
            ques.addEventListener("click", () => {
                let nextAns = ques.nextElementSibling;
                
                document.querySelectorAll(".faq__block__arrow").forEach((ans) => {
                    if(ans.classList.toString() !== "rotate"){
                        ans.classList.remove("rotate");
                    }
                });

                document.querySelectorAll(".faq__ans").forEach((ans) => {
                    if (ans !== nextAns) {
                        ans.classList.remove("show-ans");
                    }
                });

                ques.querySelector(".faq__block__arrow")?.classList.toggle("rotate")
                
                nextAns?.classList.toggle("show-ans");
            });
        });
    }, []);

    return (
        <div className="faq">
            {deviceCheck() && <div className="HelpSupportTabText">
                Answers to queries on functionalities in different user journeys
            </div>}
            <div className="faq__content">
                <div className="faq__block">
                    <div className="faq__ques">How to add new users in Read Pro CRM(Add Users)?<span className="faq__block__arrow rotate"></span></div>
                    <div className="faq__ans show-ans">
                        <ul className="faq__ans__list">
                            <li className="faq__ans__list__item">Login to Read Pro web</li>
                            <li className="faq__ans__list__item">Click on “Add User”</li>
                            <li className="faq__ans__list__item">Enter all the mandatory details of the user</li>
                            <li className="faq__ans__list__item">Click on Submit</li>
                        </ul>
                    </div>
                </div>
                <div className="faq__block">
                    <div className="faq__ques">How to Set User permissions?<span className="faq__block__arrow"></span></div>
                    <div className="faq__ans">
                        <ul className="faq__ans__list">
                            <li className="faq__ans__list__item">Login to Read Pro web</li>
                            <li className="faq__ans__list__item">Click on More Options</li>
                            <li className="faq__ans__list__item">Click on “Set User Permissions”, Select Profile or User ID
                                accordingly</li>
                            <li className="faq__ans__list__item">Set the Permissions and Click on save, your assigned permission
                                will be synced.</li>
                        </ul>
                    </div>
                </div>
                <div className="faq__block">
                    <div className="faq__ques">How to Check Active/Inactive Users ?<span className="faq__block__arrow"></span></div>
                    <div className="faq__ans">
                        <ul className="faq__ans__list">
                            <li className="faq__ans__list__item">Login to Read Pro web</li>
                            <li className="faq__ans__list__item">Click on Status Box and Select the status of Users.</li>
                        </ul>
                    </div>
                </div>
                <div className="faq__block">
                    <div className="faq__ques">How to import users in Read Pro CRM?<span className="faq__block__arrow"></span></div>
                    <div className="faq__ans">
                        <ul className="faq__ans__list">
                            <li className="faq__ans__list__item">Login the Admin Profile in Read Pro Web</li>
                            <li className="faq__ans__list__item">Click on Import Users</li>
                            <li className="faq__ans__list__item">Download the template</li>
                            <li className="faq__ans__list__item">Remove the details of the user from the downloaded file and
                                enter the details of the
                                users to be imported.</li>
                            <li className="faq__ans__list__item">Save the file, and</li>
                            <li className="faq__ans__list__item">Go back to Read Pro and click on “Import users”</li>
                            <li className="faq__ans__list__item">Click on upload file</li>
                            <li className="faq__ans__list__item">Click on upload file</li>
                            <li className="faq__ans__list__item">Select the file in which the details of the users are being
                                entered</li>
                            <li className="faq__ans__list__item">Click on Upload</li>
                        </ul>
                    </div>
                </div>
                <div className="faq__block">
                    <div className="faq__ques">How to export users in Read Pro CRM?<span className="faq__block__arrow"></span></div>
                    <div className="faq__ans">
                        <ul className="faq__ans__list">
                            <li className="faq__ans__list__item">Login the Admin Profile in Read Pro Web</li>
                            <li className="faq__ans__list__item">Select the users to be exported</li>
                            <li className="faq__ans__list__item">Click on More options button present on the right side</li>
                            <li className="faq__ans__list__item">Click on Export</li>
                        </ul>
                    </div>
                </div>
                <div className="faq__block">
                    <div className="faq__ques">How to Add API Token ?<span className="faq__block__arrow"></span></div>
                    <div className="faq__ans">
                        <ul className="faq__ans__list">
                            <li className="faq__ans__list__item">Login the Admin Profile in Read Pro web</li>
                            <li className="faq__ans__list__item">Click on API section</li>
                            <li className="faq__ans__list__item">Click on Add API, update "Lead Source" and "Country Code",
                                Save.</li>
                        </ul>
                    </div>
                </div>
                <div className="faq__block">
                    <div className="faq__ques">How to add real estate news links in Read Pro CRM?<span
                        className="faq__block__arrow"></span></div>
                    <div className="faq__ans">
                        <ul className="faq__ans__list">
                            <li className="faq__ans__list__item">Login the Admin Profile in Read Pro web</li>
                            <li className="faq__ans__list__item">Go to “News” section</li>
                            <li className="faq__ans__list__item">Click on “Add news link”</li>
                            <li className="faq__ans__list__item">Enter “Area” and “News Link”</li>
                            <li className="faq__ans__list__item">Click on Save</li>
                        </ul>
                    </div>
                </div>
                <div className="faq__block">
                    <div className="faq__ques">How to update the password of a user in Read Pro CRM?<span
                        className="faq__block__arrow"></span></div>
                    <div className="faq__ans">
                        <ul className="faq__ans__list">
                            <li className="faq__ans__list__item">Login the Admin Profile in Read Pro web</li>
                            <li className="faq__ans__list__item">Go to Update Password</li>
                            <li className="faq__ans__list__item">Enter the required details</li>
                            <li className="faq__ans__list__item">Click on Submit</li>
                        </ul>
                    </div>
                </div>
                <div className="faq__block">
                    <div className="faq__ques">How to enable or disable OTP verification for exporting or deleting leads?<span
                        className="faq__block__arrow"></span></div>
                    <div className="faq__ans">
                        <ul className="faq__ans__list">
                            <li className="faq__ans__list__item">Login the Admin Profile in Read Pro web</li>
                            <li className="faq__ans__list__item">Go to settings</li>
                            <li className="faq__ans__list__item">Click on the check box for enabling or disabling the OTP for
                                deleting or exporting data.</li>
                            <li className="faq__ans__list__item">Mention the email id to receive the OTP, if you are enabling
                                this feature.</li>
                        </ul>
                    </div>
                </div>
                <div className="faq__block">
                    <div className="faq__ques">How to edit user's details in Read Pro CRM?<span
                        className="faq__block__arrow"></span></div>
                    <div className="faq__ans">
                        <ul className="faq__ans__list">
                            <li className="faq__ans__list__item">Login the Admin Profile in Read Pro web</li>
                            <li className="faq__ans__list__item">Go to users section in Read Pro</li>
                            <li className="faq__ans__list__item">Search for the user whose information you wish to modify.</li>
                            <li className="faq__ans__list__item">Click on the edit icon (pencil icon), present just before the
                                name of the user</li>
                            <li className="faq__ans__list__item">Enter the details in the editable fields to be updated</li>
                            <li className="faq__ans__list__item">Click on update</li>
                        </ul>
                    </div>
                </div>
                <div className="faq__block">
                    <div className="faq__ques">How to activate or deactivate user in Read Pro CRM?<span
                        className="faq__block__arrow"></span></div>
                    <div className="faq__ans">
                        <ul className="faq__ans__list">
                            <li className="faq__ans__list__item">Login the Admin Profile in Read Pro web</li>
                            <li className="faq__ans__list__item">Search the user to be activated or deactivated</li>
                            <li className="faq__ans__list__item">Scroll towards right and go to Active/Inactive option</li>
                            <li className="faq__ans__list__item">Click on the toggle button to activate or deactivate the user.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="faq__block">
                    <div className="faq__ques">How to search a user in Read Pro using name or phone number?<span
                        className="faq__block__arrow"></span></div>
                    <div className="faq__ans">
                        <ul className="faq__ans__list">
                            <li className="faq__ans__list__item">Login the Admin Profile in Read Pro web</li>
                            <li className="faq__ans__list__item">Enter the name or the phone number of the user you want to
                                search, in the global search bar</li>
                        </ul>
                    </div>
                </div>
                <div className="faq__block">
                    <div className="faq__ques">How to remove cache from Read Pro App and Read Pro Web?<span
                        className="faq__block__arrow"></span></div>
                    <div className="faq__ans">
                        <div className="faq__ans__subtxt">Web:</div>
                        <ul className="faq__ans__list">
                            <li className="faq__ans__list__item">Login the Read Pro</li>
                            <li className="faq__ans__list__item">Click on View site information icon present near the refresh
                                icon</li>
                            <li className="faq__ans__list__item">Click on Site Settings</li>
                            <li className="faq__ans__list__item">Under usage, click on Delete data and reset permissions</li>
                            <li className="faq__ans__list__item">Go back to Read Pro and reload the page</li>
                        </ul>
                        <div className="faq__ans__subtxt mt8">App:</div>
                        <ul className="faq__ans__list">
                            <li className="faq__ans__list__item">On your phone, go to settings</li>
                            <li className="faq__ans__list__item">Go To Apps</li>
                            <li className="faq__ans__list__item">Select Read Pro</li>
                            <li className="faq__ans__list__item">Go to storage</li>
                            <li className="faq__ans__list__item">Click on Clear Data</li>
                            <li className="faq__ans__list__item">Click on Clear Cache</li>
                        </ul>
                    </div>
                </div>
                <div className="faq__block">
                    <div className="faq__ques">How to select new header from column manager?<span
                        className="faq__block__arrow"></span></div>
                    <div className="faq__ans">
                        <ul className="faq__ans__list">
                            <li className="faq__ans__list__item">Login the Read Pro web</li>
                            <li className="faq__ans__list__item">Go to Column Manager</li>
                            <li className="faq__ans__list__item">Select the fields</li>
                            <li className="faq__ans__list__item">Click on save</li>
                        </ul>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default Faq;